import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalizeRouterService } from 'localize-router';
import { AlertService } from '../../../app/shared/_services/alert.service.';
import { ApiService, RegistrazioneRequest } from '../../../app/shared/_services/api.service';
import { AuthService } from '../../../app/shared/_services/auth.sevice';

@Component({
  selector: 'app-registrazione',
  templateUrl: './registrazione.component.html',
  styles: []
})
export class RegistrazioneComponent implements OnInit {

  constructor(
    private auth: AuthService,
    private router: Router,
    private localize: LocalizeRouterService,
    private api: ApiService,
    private alert: AlertService
    ) { }

  user = new RegistrazioneRequest();

  errorEmailEsistente;


  ngOnInit() {
  }


  registra() {
    this.auth.registrazione(this.user).subscribe((res: any) => {
      if (res.esito === 'OK') {
        this.router.navigate([this.localize.translateRoute('/')]).then(() => this.alert.apriAlert.emit('REGISTRAZIONE_UTENTE_SUCCESS'));
        if (this.user.newsletter) {
          this.api.newsletter({email: this.user.email}).subscribe();
        }
      } else {
        this.errorEmailEsistente = res.descrizione;
      }
    });
  }
}
